import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FormioAppConfig } from 'dp-formio';

@Injectable()
export class CustomSelectService {
	/**
	 *
	 */
	constructor(
		private formioAppConfig: FormioAppConfig,
		private http: HttpClient
	) {}

	request<T = Record<string, any>[]>({
		method,
		url,
		body,
		headers,
		params,
	}: {
		method: string;
		url: string;
		body?: any;
		headers?: HttpHeaders | Record<string, string | string[]>;
		params?: Record<string, any>;
	}): Observable<T> {
		return this.http.request<any>(method, url, {
			body: body,
			headers,
			params,
		});
	}

	get<Response = any>(url: string) {
		return this.http.get<Response>(url);
	}
}
